import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../../../../../components/simple";
import SVG from "../../../../../components/SVG";
import location from "../../../../../assets/images/location-icon.png";

import styles from "./styles.module.scss";

const ModalNoRegions = ({ toggle, isOpen }) => {
  return (
    <Modal className={`modal-view ${styles.modal}`} isOpen={isOpen}>
      <SVG.Close className={`${styles["close-modal"]}`} onClick={toggle} />

      <div className={styles.container}>
        <div className={styles.icon}>
          <img src={location} alt="location" />
        </div>
        <h4 className={styles.title}>
          No regions were added. <br />
          You are targeting the whole country
        </h4>
      </div>
    </Modal>
  );
};

ModalNoRegions.propTypes = {
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
};

ModalNoRegions.defaultProps = {
  isOpen: false
};

export default ModalNoRegions;
